import { LOGOUT_SYNC_KEY } from '../../session/constants.ts';

export function clearAllOIDCInfo() {
  const keys = Object.keys(localStorage);
  for (const key of keys) {
    if (key.startsWith('oidc') && key !== LOGOUT_SYNC_KEY) {
      localStorage.removeItem(key);
    }
  }
}
